var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUiMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF462D",
  d: "M7.135 3.136a1 1 0 0 1 .728.006L12.5 4.997l3.894-1.484a1 1 0 0 1 1.356.935v9.86a1 1 0 0 1-.644.934l-4.241 1.616a1 1 0 0 1-.728-.006L7.5 14.996 3.606 16.48a1 1 0 0 1-1.356-.935v-9.86a1 1 0 0 1 .644-.934zm8.847 2.129-2.732.982v8.855l2.87-1.088a.2.2 0 0 0 .13-.187V5.453a.2.2 0 0 0-.268-.188M8.25 4.89v8.8l3.5 1.384V6.297zm-1.5 0L3.88 5.948a.2.2 0 0 0-.13.188v8.388a.2.2 0 0 0 .27.188l2.73-1.024z"
})));
export default SvgUiMap;